import useSWR from 'swr'

import fetcher from 'utils/fetcher'

const useMailTracking = ({ docImb }) => {
  const { data, isValidating, mutate } = useSWR(
    docImb ? `/mail-tracking/${docImb}` : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    trackingData: data || {},
    error: data?.error,
    embedded: data?._embedded ?? {},
    loading: (!data && !data?.error) || isValidating,
    validating: isValidating,
    count: data?.count,
    total: data?.total,
    totalPages: data?.total_pages,
    pageSize: data?.page_size,
    paginates: data?.paginates,
    mutate,
  }
}

export default useMailTracking
